<template>
  <div>
    <!-- Device Information Section -->
    <h6 class="section-title mb-3">Device Information</h6>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Device Model:</span>
      <span class="text-sm">{{ deviceInfo['Device Model'] || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Firmware Version:</span>
      <span class="text-sm">{{ deviceInfo['Firmware Version'] || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Hardware Version:</span>
      <span class="text-sm">{{ deviceInfo['Hardware Version'] || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">MAC Address:</span>
      <span class="text-sm">{{ deviceInfo['MAC Address'] || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Serial Number:</span>
      <span class="text-sm">{{ deviceInfo['Serial Number'] || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Software Created Time:</span>
      <span class="text-sm">{{ deviceInfo['Software Created Time'] || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">System Name:</span>
      <span class="text-sm">{{ deviceInfo['System Name'] || 'N/A' }}</span>
    </div>

    <!-- System Information Section -->
    <h6 class="section-title mb-3 mt-4">System Information</h6>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">CPU Usage:</span>
      <span class="text-sm">{{ systemInfoData['CPU Usage'] || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Memory Usage:</span>
      <span class="text-sm">{{ systemInfoData['Memory Usage'] || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">System Time:</span>
      <span class="text-sm">{{ systemInfoData['System Time'] || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">Running Time:</span>
      <span class="text-sm">{{ systemInfoData['Running Time'] || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">License ONUs Limit:</span>
      <span class="text-sm">{{ systemInfoData['License ONUs Limit'] || 'N/A' }}</span>
    </div>
    <div class="mb-1 d-flex justify-content-between">
      <span class="text-sm font-weight-bold">License Time:</span>
      <span class="text-sm">{{ systemInfoData['License Time'] || 'N/A' }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VsolEponSystemInfo',
  props: {
    systemInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    deviceInfo() {
      return this.systemInfo.device_info?.device_basic_information || {};
    },
    systemInfoData() {
      return this.systemInfo.device_info?.system_basic_information || {};
    }
  }
}
</script>

<style scoped>
.section-title {
  color: #82D616;
  border-bottom: 1px solid #444;
  padding-bottom: 8px;
  font-size: 0.9rem;
  font-weight: 600;
}

.text-sm {
  font-size: 0.875rem;
}

.font-weight-bold {
  font-weight: 600;
}

.mb-1 {
  margin-bottom: 0.25rem;
}

.mb-3 {
  margin-bottom: 1rem;
}

.mt-4 {
  margin-top: 1.5rem;
}
</style>